import * as React from 'react';
import './StepByStepSection.scss';
import { childClassClosure, baseClassAnd, ClassableProps } from '@jcharlesworthuk/your-mum-core/dist/functions';

const baseClass = 'step-by-step';
const childClass = childClassClosure(baseClass);


type Props = ClassableProps & {
    children: JSX.Element[];
};

const StepByStepSection: React.FunctionComponent<Props> = props => {
    return <section className={baseClassAnd(baseClass, props, props.children.length.toString() )}>
        {props.children}
    </section>
}

export default StepByStepSection;